<template>
  <div class="flex flex-col m-2">
    <div class="flex flex-row items-center">
      <input type="checkbox" style="outline: none" @input="$emit('update:modelValue', $event.target.value)" :name="checkboxName" :value="true"/>
      <label class="ml-2 text-primary text-sm">{{ checkboxLabel }} {{confirmed}}</label>
      <slot name="suffix"></slot>
      
    </div>
    <div class="flex flex-row" v-if="confirmed">
      <label class="text-primary text-sm">{{ label }}</label>
      <slot name="label"></slot>
    </div>
    <div class="py-1 px-2 my-1 rounded bg-gray-100 shadow-inner" v-if="confirmed">
      <slot name="prefix"></slot>
      <input
        class="
          border-b-2 border-gray
          focus:border-primary focus:border-b-2
          w-full
          text-sm
        "
        style="height: 36px; background: rgba(0, 0, 0, 0); outline: none"
        v-bind="$attrs"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <slot name="suffix"></slot>
    </div>
  </div>
</template>
<script setup="props">
import { defineProps, defineComponent, reactive, watch } from "vue";


// disable attribute inheritance
defineComponent({
  inheritAttrs: false,
});

// define the component props
defineProps({
  label: String,
  checkboxName: String,
  checkboxLabel: String,
  confirmed: String
});

// get the attrb on the component and bind them to the input element
// const attrs = useAttrs();
</script>
